import React, { createElement } from 'react';
import { oneOf, bool, node, string } from 'prop-types';
import MuiButton from '@mui/material/Button';
import { Icons } from '../..';
import { ButtonWrapper } from './Button.styles';
export const renderIconElement = icon => icon ? /*#__PURE__*/createElement(Icons[icon]) : undefined;
export const Button = _ref => {
  let {
    disabled,
    fullWidth,
    target,
    transform,
    size,
    variant,
    children,
    color,
    startIcon,
    endIcon,
    onClick,
    href,
    backgroundColour
  } = _ref;
  const handleClick = event => {
    if (href && href !== '') return null;
    event.preventDefault();
    return onClick(event);
  };
  return /*#__PURE__*/React.createElement(ButtonWrapper, {
    transform: transform,
    color: color,
    size: size,
    backgroundColour: backgroundColour
  }, /*#__PURE__*/React.createElement(MuiButton, {
    disableElevation: true,
    disableRipple: true,
    "data-test-id": "button",
    disabled: disabled,
    fullWidth: fullWidth,
    variant: variant,
    size: size !== 'extra-large' ? size : 'medium',
    startIcon: renderIconElement(startIcon),
    endIcon: renderIconElement(endIcon),
    onClick: event => handleClick(event),
    href: href,
    target: target
  }, children));
};
Button.propTypes = {
  children: node.isRequired,
  fullWidth: bool,
  disabled: bool,
  variant: oneOf(['outlined', 'contained']),
  size: oneOf(['extra-large', 'large', 'medium', 'small']),
  target: oneOf(['_self', '_blank']),
  transform: oneOf(['initial', 'uppercase']),
  color: oneOf(['blue', 'green', 'purple', 'pink', 'white', 'branded', 'linkedInBlue']),
  backgroundColour: string,
  startIcon: string,
  endIcon: string,
  href: props => {
    return !props.href && !props.onClick && new Error('One of props "href" or "onClick" was not specified.');
  },
  onClick: props => {
    return !props.href && !props.onClick && new Error('One of props "href" or "onClick" was not specified.');
  }
};
Button.defaultProps = {
  disabled: false,
  fullWidth: false,
  variant: 'outlined',
  size: 'medium',
  target: '_self',
  transform: 'initial',
  color: 'blue',
  startIcon: '',
  endIcon: '',
  href: '',
  onClick: () => {},
  backgroundColour: 'transparent'
};